export default "__VITE_ASSET__C37fKKu9__"